import type { APIApplicationFile } from 'types/api.types';
import { useApplicationFiles } from './useApplicationFiles';

export const useBinderAdditionalFiles = (
  uuid: string,
  initialFiles?: APIApplicationFile[],
) => {
  const {
    files,
    isUploadingFile,
    deletingFileId,
    handleFilesUpload,
    handleFileRemove,
    resetFiles,
  } = useApplicationFiles(uuid, 'additional', { initialFiles });

  return {
    additionalFiles: files,
    isUploadingFile,
    deletingFileId,
    handleFilesUpload,
    handleFileRemove,
    resetFiles,
  };
};
